import { Fragment } from 'react';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';

type RowIfNotEmptyOpts = {
  valueClass?: string;
  key?: string;
  // truncate keeps the value on a single line, clips overflow with an ellipsis,
  // and shows the full value in a tooltip on hover.
  truncate?: boolean;
};

// RowIfNotEmpty will display a row if the value is defined
export default function RowIfNotEmpty(heading: string, value?: string, opts?: RowIfNotEmptyOpts): JSX.Element {
  if (value !== undefined && value != '') {
    return (
      <TableRow key={opts?.key}>
        <TableCell sx={{ overflowWrap: 'break-word' }}>{heading}</TableCell>
        {opts?.truncate ? (
          <TableCell align="right" className={opts?.valueClass} sx={{ maxWidth: 0 }}>
            <Tooltip title={value} arrow placement="top">
              <span
                style={{
                  display: 'block',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {value}
              </span>
            </Tooltip>
          </TableCell>
        ) : (
          <TableCell sx={{ overflowWrap: 'break-word' }} align="right" className={opts?.valueClass}>
            {value}
          </TableCell>
        )}
      </TableRow>
    );
  } else {
    return <Fragment key={opts?.key} />;
  }
}
